import React from 'react';

import { colorContentDim } from '@duxton-web/design-tokens/themes/light';
import { Empty, Typography } from '@duxton-web/ui';

type EmptyContentProps = {
  image?: React.ReactNode;
  imageWidth?: number;
  imageHeight?: number;
  description?: string;
  title?: string;
};

const EmptyContent = ({
  image,
  imageWidth,
  imageHeight,
  description,
  title,
}: EmptyContentProps) => {
  return (
    <Empty
      image={image}
      imageStyle={{
        width: imageWidth || 92,
        height: imageHeight || 60,
        marginRight: 'auto',
        marginLeft: 'auto',
      }}
      description={
        description && (
          <Typography.Title level={3}>{description}</Typography.Title>
        )
      }
      children={
        title && (
          <Typography.Body level={3} style={{ color: colorContentDim }}>
            {title}
          </Typography.Body>
        )
      }
    />
  );
};

export default EmptyContent;
